export const REPORT_TYPE_OPTIONS = {
  '': 'All report types',
  still_available: 'Still available on store',
  data_too_old: 'Data too old',
  other: 'Other',
};

export const REVIEW_FILTER_OPTIONS = {
  '': 'All',
  needs_review: 'Needs review',
  reviewed: 'Reviewed',
};

export const REPORT_TYPE_CHIP_COLORS = {
  still_available: { bg: '#e3f2fd', color: '#1565c0' },
  data_too_old: { bg: '#fff3e0', color: '#e65100' },
  other: { bg: '#f3e5f5', color: '#6a1b9a' },
};

export const REVIEW_CHIP_STYLES = {
  needsReview: { backgroundColor: '#fb9eac', color: '#fff' },
  reviewed: { backgroundColor: '#00B04F', color: '#fff' },
  pending: { backgroundColor: '#fb9eac', color: '#fff' },
};

export const STALE_PRICE_VIEWS = {
  reports: {
    id: 'reports',
    label: 'All Reports',
    path: '/company-report-tool-stale-price-reports',
  },
  byPmg: {
    id: 'byPmg',
    label: 'By PMG',
    path: '/company-report-tool-stale-price-reports-by-pmg',
  },
  byBanner: {
    id: 'byBanner',
    label: 'By Banner',
    path: '/company-report-tool-stale-price-reports-by-banner',
  },
  byCity: {
    id: 'byCity',
    label: 'By City',
    path: '/company-report-tool-stale-price-reports-by-city',
  },
};

export const formatDate = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleDateString();
};

export const formatDateTime = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleString();
};

export const getSortValue = (row, sortKey, type) => {
  const val = row[sortKey];
  if (val == null || val === '') return null;
  if (type === 'date') return new Date(val).getTime();
  if (type === 'boolean') return val ? 1 : 0;
  if (type === 'number') return Number(val);
  return String(val).toLowerCase();
};

export const DEFAULT_FILTERS = {
  city: '',
  banners: [],
  reportType: '',
  fromDate: '',
  toDate: '',
  reporter: '',
  review: '',
  search: '',
};

export function parseStalePriceFiltersFromSearch(search) {
  const params = new URLSearchParams(search || '');
  const bannersRaw = params.get('banners');
  return {
    city: params.get('city') || '',
    banners: bannersRaw ? bannersRaw.split(',').filter(Boolean) : [],
    reportType: params.get('report_type') || '',
    fromDate: params.get('from') || '',
    toDate: params.get('to') || '',
    reporter: params.get('reporter') || '',
    review: params.get('review') || '',
    search: params.get('q') || '',
  };
}

export function serializeStalePriceFiltersToSearch(filters) {
  const params = new URLSearchParams();
  if (filters.city) params.set('city', filters.city);
  if (filters.banners && filters.banners.length > 0) {
    params.set('banners', filters.banners.join(','));
  }
  if (filters.reportType) params.set('report_type', filters.reportType);
  if (filters.fromDate) params.set('from', filters.fromDate);
  if (filters.toDate) params.set('to', filters.toDate);
  if (filters.reporter) params.set('reporter', filters.reporter);
  if (filters.review) params.set('review', filters.review);
  if (filters.search) params.set('q', filters.search);
  const query = params.toString();
  return query ? `?${query}` : '';
}

export function buildStalePriceReportUrl(viewPath, userTypeId, projectId, filters) {
  const base = `${viewPath}/${userTypeId}/${projectId}`;
  return `${base}${serializeStalePriceFiltersToSearch(filters)}`;
}

export function countSecondaryFilters(filters) {
  let count = 0;
  if (filters.reportType) count += 1;
  if (filters.fromDate || filters.toDate) count += 1;
  if (filters.reporter) count += 1;
  if (filters.review) count += 1;
  return count;
}

export function countActiveFilters(filters) {
  let count = countSecondaryFilters(filters);
  if (filters.city) count += 1;
  if (filters.banners && filters.banners.length > 0) count += 1;
  if (filters.search) count += 1;
  return count;
}

export function getActiveFilterChips(filters, reporterOptions = []) {
  const chips = [];

  if (filters.city) {
    chips.push({ key: 'city', label: `City: ${filters.city}`, clearKey: 'city' });
  }
  if (filters.banners && filters.banners.length > 0) {
    chips.push({
      key: 'banners',
      label: `Banners: ${filters.banners.join(', ')}`,
      clearKey: 'banners',
    });
  }
  if (filters.reportType) {
    chips.push({
      key: 'reportType',
      label: `Type: ${REPORT_TYPE_OPTIONS[filters.reportType] || filters.reportType}`,
      clearKey: 'reportType',
    });
  }
  if (filters.fromDate || filters.toDate) {
    chips.push({
      key: 'dates',
      label: `Dates: ${filters.fromDate || '...'} – ${filters.toDate || '...'}`,
      clearKey: 'dates',
    });
  }
  if (filters.reporter) {
    const reporter = reporterOptions.find((opt) => opt.value === filters.reporter);
    chips.push({
      key: 'reporter',
      label: `Reporter: ${reporter?.label || filters.reporter}`,
      clearKey: 'reporter',
    });
  }
  if (filters.review) {
    chips.push({
      key: 'review',
      label: `Review: ${REVIEW_FILTER_OPTIONS[filters.review] || filters.review}`,
      clearKey: 'review',
    });
  }
  if (filters.search) {
    chips.push({
      key: 'search',
      label: `Search: "${filters.search}"`,
      clearKey: 'search',
    });
  }

  return chips;
}

export function clearFilterKey(filters, clearKey) {
  const next = { ...filters };
  switch (clearKey) {
    case 'city':
      next.city = '';
      break;
    case 'banners':
      next.banners = [];
      break;
    case 'reportType':
      next.reportType = '';
      break;
    case 'dates':
      next.fromDate = '';
      next.toDate = '';
      break;
    case 'reporter':
      next.reporter = '';
      break;
    case 'review':
      next.review = '';
      break;
    case 'search':
      next.search = '';
      break;
    default:
      break;
  }
  return next;
}
